import type { AtmospherePreset } from '../presets.config';
import { multiPlaneParallax } from '../presetBuilders';
import { TIDEWEND_SHARED_BED } from './tidewend';
import { OUTSKIRTS_SILHOUETTES } from '../../../game/effects/atmosphere/silhouettes/outskirtsSilhouettes';
import { JOURNEY_DEPTH_BACKDROPS, JOURNEY_DEPTH_HEIGHTS } from '../../../game/effects/atmosphere/silhouettes/journeyDepthBackdrops';

const PASTURE_PLANES = multiPlaneParallax([
  { shape: 'ridge', color: 0x2f3d45, speed: 0.025, height: JOURNEY_DEPTH_HEIGHTS.outskirts, alpha: 0.52, svg: JOURNEY_DEPTH_BACKDROPS.outskirts, occludeCelestial: true },
  { shape: 'ridge', color: 0x29383e, speed: 0.07, height: 360, alpha: 0.87, svg: OUTSKIRTS_SILHOUETTES.pasture },
  { shape: 'ridge', color: 0x1c2c31, speed: 0.14, height: 220, alpha: 0.91, svg: OUTSKIRTS_SILHOUETTES.reeds },
]);

/** The farms have their own scenery, while the original night, weather and
 * localized light remain shared. Town and port never consume these planes.
 * The authored map horizon positions all three without a first-view landmark. */
export const TIDEWEND_OUTSKIRTS: AtmospherePreset = Object.freeze({
  ...TIDEWEND_SHARED_BED,
  id: 'tidewend_outskirts',
  layers: TIDEWEND_SHARED_BED.layers.map(layer => layer.kind === 'parallax'
    ? PASTURE_PLANES.find(plane => plane.depth === layer.depth) ?? layer : layer),
});
